import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState, } from "react";
const DrawerManagerContext = createContext(null);
export const DrawerProvider = ({ children, }) => {
    const [active, setActive] = useState(null);
    useEffect(() => {
        const body = document.body;
        if (!body)
            return;
        if (active) {
            const previousOverflow = body.style.overflow;
            body.style.overflow = "hidden";
            return () => {
                body.style.overflow = previousOverflow;
            };
        }
        body.style.overflow = "";
        return () => {
            body.style.overflow = "";
        };
    }, [active]);
    const value = useMemo(() => ({
        active,
        open: (id) => setActive(id),
        close: () => setActive(null),
        toggle: (id) => setActive((current) => (current === id ? null : id)),
        isOpen: (id) => active === id,
    }), [active]);
    return (_jsx(DrawerManagerContext.Provider, { value: value, children: children }));
};
export function useDrawerManager() {
    const ctx = useContext(DrawerManagerContext);
    if (!ctx)
        throw new Error("useDrawerManager must be used within DrawerProvider");
    return ctx;
}
